import { render, staticRenderFns } from "./kaoDianJingJiang.vue?vue&type=template&id=de6b6610&scoped=true&"
import script from "./kaoDianJingJiang.vue?vue&type=script&lang=js&"
export * from "./kaoDianJingJiang.vue?vue&type=script&lang=js&"
import style0 from "./kaoDianJingJiang.vue?vue&type=style&index=0&id=de6b6610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6b6610",
  null
  
)

export default component.exports